require('normalize.css/normalize.css');
require('styles/App.css');

import React from 'react';
import {Helmet} from "react-helmet";

import * as dat from 'dat.gui';

class AppComponent extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      color1: '#0000ff',
      color2: '#ff0000',
      rotate: 45,
      scale: 0.7,
      skew: 0,
      blending: [ 'normal', 'multiply', 'screen', 'overlay', 'darken', 'lighten', "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity" ]
    }

    this._color1 = this._color1.bind(this)
    this._color2 = this._color2.bind(this)
    this._scroll = this._scroll.bind(this)
    this._rotate = this._rotate.bind(this)
    this._scale = this._scale.bind(this)
    this._skew = this._skew.bind(this)
    this._blending = this._blending.bind(this)
    
  }

  componentDidMount(){
    window.addEventListener("scroll", this._scroll)
    
    const {
      color1, color2,
      rotate, scale, skew, blending
    } = this.state;

    const gui = new dat.GUI();
    gui.addColor(this.state, 'color1').onChange(this._color1);
    gui.addColor(this.state, 'color2').onChange(this._color2);
    gui.add(this.state, 'rotate', 0, 360).onChange(this._rotate);
    gui.add(this.state, 'scale', 0, 1, 0.05).onChange(this._scale);
    gui.add(this.state, 'skew', 0, 360).onChange(this._skew);
    gui.add(this.state, 'blending', blending ).onChange(this._blending);
  }

  _scroll(){
    const scroll = -window.pageYOffset
    this.refs.scrollX.style.transform = 'translateX('+scroll+'px)'
  }

  _color1(value){
    this.setState({color1:  value})
  }
  _color2(value){
    this.setState({color2:  value})
  }
  _rotate(value){
    this.setState({rotate:  Math.round(value)})
  }
  _scale(value){
    this.setState({scale:  value})
  }
  _skew(value){
    this.setState({skew: Math.round(value)})
  }

  _blending(value){
    this.setState({blending: value})
  }

  render() {
    const length = 1000
    const array = new Array(length).fill(length);

    const {
      color1, color2,
      rotate, scale, skew, blending
    } = this.state;

    const style = {
      backgroundColor: color2,
      transform: 'rotate('+rotate+'deg) scale('+scale+') skew('+skew+'deg)'
    }

    const blendingStyle = {
      mixBlendMode: blending
    }
   
    return (
      <div className="index">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Patttttern Scroooool</title>
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Patttttern Scroooool" />
          <meta property="og:site_name" content="Patttttern Scroooool" />
          <meta property="og:url" content="https://ahmedghazi.github.io/patttttern/" />
          <meta property="og:image" content="https://ahmedghazi.github.io/patttttern/static/poster.png" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@Bounews" />
          <meta name="twitter:title" content="Patttttern" />
          <meta name="twitter:description" content="scrolllll" />
          <meta name="twitter:image" content="https://ahmedghazi.github.io/patttttern/static/poster.png" />
        </Helmet>
        <div className="scroll-y">
          <div className="flex">
            {array.map((el, i) => (
              <div className="item" key={i+el}>
                <div className="circle" style={{
                  backgroundColor: color1
                }}></div>
              </div>
            ))}
          </div>
        </div>

        <div className="scroll-x" ref="scrollX" style={{
          mixBlendMode: blending
        }}>
          <div className="flex">
            {array.map((el, i) => (
              <div className="item" key={el+i}>
                <div className="square" style={style}></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

AppComponent.defaultProps = {
};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/Main.js